import {Button, Test} from "../../components";
import pic from '../../resources/screen2.jpg';
import {useState} from "react";
import Shuffle from "../../services/Shuffle";
import styles from "../../components/Button/Button.module.scss";

const text = "В какой из этих песен действительно есть слово «уши»?",
    arr = [
        {
            name: "Тополиный ух жара июль",
            desc: "Кажется, в этой песне было что-то про аллергию на пух?"
        },
        {
            name: "Чужие уши тебя ласкают",
            desc: "У всех предпочтения разные, но руки как-то привычнее!"
        },
        {
            name: "Хлопай ушами и взлетай",
            desc: "Братья Грим умеют взлетать только на ресницах"
        },
        {
            name: "Вдохни поглубже, у тебя необычно большие уши",
            desc: "Точно! Это песня Кристины Кошелевой",
            answer: true
        }
    ];

export const SecondTest = ({handler}) => {
    const [success, setStep] = useState(false);
    const buttonText = success ? "И это правильный ответ" : "Выберите ответ",
        buttonType = !success ? 'disabled' : 'active';

    return (
        <Test desc={text} arr={Shuffle(arr)} pic={pic} handler={setStep}>
            <Button id="button-test-2" className={styles.mobile} text={buttonText} handler={success ? handler : () => null} type={buttonType}/>
        </Test>
    )
}